import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Helmet } from "react-helmet-async";
import { TImage } from "_common/types/baseTypes";
import { CardGalleryLabelType } from "properties/propertyCard/components/PropertyCardComponents";
import { useTranslation } from "react-i18next";

interface Props {
    community: {
        _id: string;
        photos: TImage[];
    };
}

export function CommunityCardGallery({ community }: Props) {
    const { t } = useTranslation();
    return (
        <div className="w-full overflow-hidden h-[277px] group">
            <Helmet>
                <link rel="preload" as="image" href={community.photos?.[0]?.url} />
                <link rel="preload" as="image" href={community.photos?.[1]?.url} />
            </Helmet>
            <LazyLoadImage
                src={community.photos?.[1]?.url ?? "https://placehold.co/300x200?text=Zisla.com"}
                alt={"community-page image"}
                title={`photo 2`}
                className="absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out opacity-0 group-hover:opacity-100 rounded-lg"
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    // currentTarget.src = new URL(`https://zisla.com/${community-page.photos?.[1]?.url}`).href;
                    currentTarget.src = `https://placehold.co/300x200?text=Zisla.com`;
                }}
            />

            <LazyLoadImage
                src={community.photos?.[0]?.url ?? "https://placehold.co/300x200?text=Zisla.com"}
                alt={"community-page image"}
                title={`photo 1`}
                className="absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out opacity-100 group-hover:opacity-0 rounded-lg"
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    // currentTarget.src = new URL(`https://zisla.com/${community-page.photos?.[0]?.url}`).href;
                    currentTarget.src = `https://placehold.co/300x200?text=Zisla.com`;
                }}
            />

            <CardGalleryLabelType type={t("communitiesPage.community")} />
        </div>
    );
}
